//	------------------------	------------------------	------------------------
//	Description: Conditional banner - shown only when condition is met
//  Version: 1.0.0
//  Updates: 
//	------------------------	------------------------	------------------------

//	------------------------	------------------------	------------------------
//	Imports
//	------------------------	------------------------	------------------------

import { Link } from 'react-router'
import { Message } from './v2/Message'
import { useUserData } from "xAppLib/Hooks"

//	------------------------	------------------------	------------------------
//	Globals
//	------------------------	------------------------	------------------------

const ResultsBanner = ({ hide_zero = false }) => {
    const [value] = useUserData('unseen_results', 0)
    const [valueExpress] = useUserData('unseen_results_express', 0)
    const show_counter = !(value + valueExpress == 0 && hide_zero)
    if (!show_counter) return null
    return (
        <ul className="flex w-full gap-x-2">
            {(value > 0) &&
                <li className="flex-auto">
                    <Link to={'/results_followup_all'}>
                        <Message
                            variant="error"
                            color="red"
                            header={`${value} patient referral${value > 1 ? 's' : ''} with unseen results`}
                            content={`Please visit the Results and Followup page to review your patient's pathology results`}
                        />
                    </Link>
                </li>
            }
            {(valueExpress > 0) &&
                <li className="flex-auto">
                    <Link to={'/results_followup_all'}>
                        <Message
                            variant="error"
                            color="pink"
                            header={`${valueExpress} express referral${valueExpress > 1 ? 's' : ''} unseen results`}
                            content={`Please visit the Results and Followup page to review your patient's express pathology results`}
                        />
                    </Link>
                </li>
            }
        </ul>
    )
}
 
export default ResultsBanner;
